(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("pCloudSdk", [], factory);
	else if(typeof exports === 'object')
		exports["pCloudSdk"] = factory();
	else
		root["pCloudSdk"] = factory();
})(window, function() {
return 